<template>
  <div>
    <v-container fluid>
      <v-container fluid text-xs-center text-md-center text-sm-center>
        <v-layout row wrap py-3>
          <v-flex d-flex offset-sm9 xs12 sm3 md3 align-self-center>
            <template v-if="matchType === 'user'">
              <v-flex xs12>{{
                (match.userName ? match.userName.name : '-').toUpperCase()
              }}</v-flex>
            </template>
            <template v-else>
              <v-flex xs12 sm6>{{
                `${(match.homeTeam || '-').toUpperCase()} (${$t(
                  'homeTeamTitle'
                )})`
              }}</v-flex>
              <v-flex xs12 sm6>{{
                `${(match.visitorTeam || '-').toUpperCase()} (${$t(
                  'visitorTeamTitle'
                )})`
              }}</v-flex>
            </template>
          </v-flex>
        </v-layout>

        <hr />
        <v-layout row wrap py-3>
          <v-flex offset-md1 xs12 sm7 md7 align-self-center>
            <b>{{ $t('matchResult') }}</b>
          </v-flex>
          <v-flex offset-md1 offset-sm1 d-flex xs12 sm3 md3 align-self-center3>
            <template v-if="matchType === 'user'">
              <v-flex xs12 sm12 md12>
                <span v-if="judgeId" class="blue--text"
                  >{{ getJudgeResult.user.result.totalScore }} /</span
                >
                <span>{{ getResult.user.totalScore }}</span>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs6 sm6 md6>
                <span v-if="judgeId" class="blue--text"
                  >{{ getJudgeResult.homeTeam.result.totalScore }} /</span
                >
                <span>{{ getResult.homeTeam.totalScore }}</span>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <span v-if="judgeId" class="blue--text"
                  >{{ getJudgeResult.visitorTeam.result.totalScore }} /</span
                >
                <span>{{ getResult.visitorTeam.totalScore }}</span>
              </v-flex>
            </template>
          </v-flex>
        </v-layout>
        <hr />
        <v-layout row wrap py-3>
          <v-flex xs12 sm2 md2 align-self-center>
            <b>{{ $t('faults') }}</b>
          </v-flex>
          <v-flex offset-md1 offset-sm1 xs12 sm9 md9>
            <v-layout row wrap py-2>
              <v-flex xs12 sm7 md7 align-self-center>{{
                $t('smallFaults')
              }}</v-flex>
              <v-flex
                d-flex
                offset-md1
                offset-sm1
                xs12
                sm4
                md4
                align-self-center
              >
                <template v-if="matchType === 'user'">
                  <v-flex xs12>
                    <span v-if="judgeId" class="blue--text"
                      >{{
                        `${
                          getJudgeResult.user.result.smallFaults
                        } (${-getJudgeResult.user.result.totalSmallFaults})`
                      }}
                      /</span
                    >
                    <span>{{
                      `${getResult.user.smallFaults} (${-getResult.user
                        .totalSmallFaults})`
                    }}</span>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12 sm6>
                    <span v-if="judgeId" class="blue--text"
                      >{{
                        `${
                          getJudgeResult.homeTeam.result.smallFaults
                        } (${-getJudgeResult.homeTeam.result.totalSmallFaults})`
                      }}
                      /</span
                    >
                    <span>{{
                      `${getResult.homeTeam.smallFaults} (${-getResult.homeTeam
                        .totalSmallFaults})`
                    }}</span>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <span v-if="judgeId" class="blue--text"
                      >{{
                        `${
                          getJudgeResult.visitorTeam.result.smallFaults
                        } (${-getJudgeResult.visitorTeam.result
                          .totalSmallFaults})`
                      }}
                      /</span
                    >
                    <span>{{
                      `${getResult.visitorTeam.smallFaults} (${-getResult
                        .visitorTeam.totalSmallFaults})`
                    }}</span>
                  </v-flex>
                </template>
              </v-flex>
            </v-layout>
            <v-layout row wrap py-2>
              <v-flex xs12 sm7 align-self-center>{{
                $t('seriousFaults')
              }}</v-flex>
              <v-flex
                d-flex
                offset-md1
                offset-sm1
                xs12
                sm4
                md4
                align-self-center
              >
                <template v-if="matchType === 'user'">
                  <v-flex xs12>
                    <span v-if="judgeId" class="blue--text"
                      >{{
                        `${
                          getJudgeResult.user.result.seriousFaults
                        } (${-getJudgeResult.user.result.totalSeriousFaults})`
                      }}
                      /</span
                    >
                    <span>{{
                      `${getResult.user.seriousFaults} (${-getResult.user
                        .totalSeriousFaults})`
                    }}</span>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12 sm6>
                    <span v-if="judgeId" class="blue--text"
                      >{{
                        `${
                          getJudgeResult.homeTeam.result.seriousFaults
                        } (${-getJudgeResult.homeTeam.result
                          .totalSeriousFaults})`
                      }}
                      /</span
                    >
                    <span>{{
                      `${getResult.homeTeam.seriousFaults} (${-getResult
                        .homeTeam.totalSeriousFaults})`
                    }}</span>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <span v-if="judgeId" class="blue--text"
                      >{{
                        `${
                          getJudgeResult.visitorTeam.result.seriousFaults
                        } (${-getJudgeResult.visitorTeam.result
                          .totalSeriousFaults})`
                      }}
                      /</span
                    >
                    <span>{{
                      `${getResult.visitorTeam.seriousFaults} (${-getResult
                        .visitorTeam.totalSeriousFaults})`
                    }}</span>
                  </v-flex>
                </template>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <hr />
        <v-layout row wrap py-3>
          <v-flex offset-md1 xs12 sm7 md7 align-self-center>
            <b>{{ $t('total') }}</b>
          </v-flex>
          <v-flex offset-md1 d-flex xs12 sm3 md align-self-center3>
            <template v-if="matchType === 'user'">
              <v-flex xs12 sm12 md12>
                <b v-if="!match.finalScoreUser">
                  <span v-if="judgeId" class="blue--text"
                    >{{ getJudgeResult.user.result.totalPoints }} /</span
                  >
                  <span>{{ getResult.user.totalPoints }}</span>
                </b>
                <b v-else class="red--text">{{ match.finalScoreUser }} *</b>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs6 sm6 md6>
                <b v-if="!match.finalScoreHomeTeam">
                  <span v-if="judgeId" class="blue--text"
                    >{{ getJudgeResult.homeTeam.result.totalPoints }} /</span
                  >
                  <span>{{ getResult.homeTeam.totalPoints }}</span>
                </b>
                <b v-else class="red--text">{{ match.finalScoreHomeTeam }} *</b>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <b v-if="!match.finalScoreVisitTeam">
                  <span v-if="judgeId" class="blue--text"
                    >{{ getJudgeResult.visitorTeam.result.totalPoints }} /</span
                  >
                  <span>{{ getResult.visitorTeam.totalPoints }}</span>
                </b>
                <b v-else class="red--text"
                  >{{ match.finalScoreVisitTeam }} *</b
                >
              </v-flex>
            </template>
          </v-flex>
        </v-layout>
        <hr />
      </v-container>
      <v-container pt-2 fluid text-xs-right>
        <v-flex xs12 v-if="judgeId">
          <span style="color:blue">*</span>
          <span>{{ $t('messages.judgeResults') }}</span>
        </v-flex>
        <v-flex
          xs12
          v-if="
            match.finalScoreVisitTeam ||
              match.finalScoreHomeTeam ||
              match.finalScoreUser
          "
        >
          <span style="color:red">*</span>
          <span>{{ $t('messages.resultModified') }}</span>
        </v-flex>
        <v-flex xs12 v-if="judgeId">
          <v-btn
            v-if="finalized"
            @click="openMatch()"
            :loading="loading"
            :disabled="!edit"
            color="primary"
            small
            >{{ $t('reopen') }}</v-btn
          >
          <v-btn
            @click="$emit('syncScore')"
            :loading="syncScoreLoading"
            :disabled="isScoreSync"
            color="primary"
            small
            >{{ $t('send') }}</v-btn
          >
          <v-btn
            @click="finalizeMatch()"
            :disabled="finalized || !isScoreSync || !edit"
            :loading="loading && !finalized"
            color="error"
            small
            >{{ $t('close') }}</v-btn
          >
        </v-flex>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'tabResults',
  props: {
    matchType: {
      type: String,
      required: true,
      default: ''
    },
    finalized: {
      type: Boolean,
      required: true,
      default: false
    },
    edit: {
      type: Boolean,
      required: true,
      default: false
    },
    isScoreSync: {
      type: Boolean,
      default: true
    },
    syncScoreLoading: {
      type: Boolean,
      default: false
    },
    judgeId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      // faults: [],
      // faultTemplate: {
      //   type: '',
      //   objectId: '',
      //   seriousFaults: 0,
      //   smallFaults: 0,
      //   warnings: 0
      // },
      resultTemplate: {
        objectId: '',
        judgeId: '',
        totalScore: 0,
        totalSmallFaults: 0,
        smallFaults: 0,
        totalSeriousFaults: 0,
        seriousFaults: 0,
        totalPoints: 0,
        warnings: 0
      }
      // userResults: {
      //   objectId: '',
      //   totalScore: 0,
      //   totalSmallFaults: 0,
      //   totalSeriousFaults: 0,
      //   totalPoints: 0
      // },
      // homeTeamResults: {
      //   objectId: '',
      //   totalScore: 0,
      //   totalSmallFaults: 0,
      //   totalSeriousFaults: 0,
      //   totalPoints: 0
      // },
      // visitorTeamResults: {
      //   objectId: '',
      //   totalScore: 0,
      //   totalSmallFaults: 0,
      //   totalSeriousFaults: 0,
      //   totalPoints: 0
      // }
    }
  },

  computed: {
    ...mapState({
      act: state => state.acts.actSelected,
      match: state => state.matches.matchSelected,
      matchId: state => state.matches.idSelected,
      scoreResults: state => state.acts.scoreResults,
      judgesScores: state => state.acts.judgesScores,
      scoreId: state => state.matches.scoreId,
      pendingAspects: state => state.matches.pendingAspects,
      pendingFaults: state => state.matches.pendingFaults
    }),
    getJudgeResult() {
      const judgeId = this.judgeId

      const getResult = objectId => {
        return (
          this.judgesScores.find(
            item => item.objectId === objectId && item.judgeId === judgeId
          ) || this.resultTemplate
        )
      }

      const items = {
        homeTeam: {
          objectId: this.match.homeTeamId,
          result: getResult(this.match.homeTeamId)
        },
        visitorTeam: {
          objectId: this.match.visitorTeamId,
          result: getResult(this.match.visitorTeamId)
        },
        user: {
          objectId: this.match.user,
          result: getResult(this.match.user)
        }
      }
      Object.keys(items).forEach(key => {
        const result = items[key].result
        const objectId = items[key].objectId
        if (!result.totalScore) {
          const aspects = this.pendingAspects[this.scoreId]
          if (aspects) {
            result.totalScore = aspects.reduce((totalScore, aspect) => {
              if (aspect.objectId === objectId && aspect.judgeId === judgeId) {
                return totalScore + aspect.score
              }
              return totalScore
            }, 0)
          }
        }
        if (!result.smallFaults || !!result.seriousFaults) {
          const faults = this.pendingFaults[this.scoreId]
          if (faults) {
            const [smallFaults, seriousFaults] = faults.reduce(
              (totalFaults, fault) => {
                const result = totalFaults.slice()
                if (fault.objectId === objectId && fault.judgeId === judgeId) {
                  if (fault.smallFaults) {
                    result[0] = result[0] + fault.smallFaults
                  }
                  if (fault.seriousFaults) {
                    result[1] = result[1] + fault.seriousFaults
                  }
                }
                return result
              },
              [0, 0]
            )
            if (!result.smallFaults) result.smallFaults = smallFaults
            if (!result.seriousFaults) result.seriousFaults = seriousFaults
          }
        }

        if (this.act && this.act.faultSystem) {
          if (!result.totalSmallFaults) {
            result.totalSmallFaults =
              result.smallFaults * this.act.smallFaultNumber
          }
          if (!result.totalSeriousFaults) {
            result.totalSeriousFaults =
              result.seriousFaults * this.act.seriousFaultNumber
          }
        }
        if (!result.totalPoints) {
          result.totalPoints = result.totalScore
          if (this.act && this.act.faultSystem) {
            result.totalPoints =
              result.totalPoints -
              result.totalSmallFaults -
              result.totalSeriousFaults
          }
        }
      })

      return items
    },
    getResult() {
      const getResult = objectId => {
        const result = this.scoreResults.find(
          item => item.objectId === objectId
        )
        return result || this.resultTemplate
      }
      return {
        homeTeam: getResult(this.match.homeTeamId),
        visitorTeam: getResult(this.match.visitorTeamId),
        user: getResult(this.match.user)
      }
    }
  },
  methods: {
    ...mapActions({
      setUpdate: 'matches/setUpdate',
      syncCurrentScore: 'matches/syncCurrentScore',
      getOne: 'matches/setOne'
    }),
    async finalizeMatch() {
      try {
        if (!this.judgeId) return
        this.loading = true
        await this.getOne(this.match._id)
        let judgesFinalized = this.match.judgesFinalized

        judgesFinalized.push({ finalized: true, judgeId: this.judgeId })

        let match = {
          _id: this.match._id,
          judgesFinalized
        }
        await this.setUpdate(match)
        await this.getOne(this.match._id)
      } finally {
        this.loading = false
      }
    },
    async openMatch() {
      try {
        if (!this.judgeId) return
        this.loading = true
        await this.getOne(this.match._id)

        let judgesFinalized = this.match.judgesFinalized
        let index = judgesFinalized.findIndex(
          item => item.judgeId == this.judgeId
        )
        judgesFinalized.splice(index, 1)

        let match = {
          _id: this.match._id,
          judgesFinalized
        }
        await this.setUpdate(match)
        await this.getOne(this.match._id)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped></style>
